import { createChildTablePrintContainer } from 'factories/ChildTablePrint'
import Component from 'components/CycleCounts/Print/Items'

export default createChildTablePrintContainer()(Component)
